import { HTTPFetchError } from '@racemap/utilities/api-client';
import { toastError } from 'src/components/utils/Utils';
import type { SWRConfiguration } from 'swr';

export const swrConfig: SWRConfiguration = {
  onError: (error) => {
    if (process.env.NODE_ENV !== 'production') {
      if (error instanceof HTTPFetchError && error.status === 403) {
        console.warn(
          'Access forbidden. This may be due to insufficient permissions or an expired session.',
        );
      } else {
        toastError('An error occurred while fetching data. Please try again later.');
      }

      console.error(error);
    }
  },
};
